import { createAsset } from '@/organisms/AngelPlayer'
import { IntroMeta } from '@/services/TorchesService/types'

interface UseIntroAssetParameters {
  heroMeta: IntroMeta | undefined
  name: string
  subtitle: string
  slug: string
  videoType: 'torch'
}

export const useIntroAsset = ({ heroMeta, name, subtitle, slug, videoType }: UseIntroAssetParameters) => {
  if (!heroMeta) return null

  return createAsset({
    name,
    subtitle,
    slug,
    videoType,
    guid: heroMeta.id,
    url: heroMeta.videoWebUrl,
    poster: heroMeta.posterWebUrl,
    title: '',
    description: heroMeta.description,
    position: 0,
  })
}
